var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rule-settings" }, [
    _c("div", { staticClass: "item-wrapper" }, [
      _c("span", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.$t("ticimax.automationRuleName")) + ":"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "options" },
        [
          _c("a-input", {
            model: {
              value: _vm.clone.name,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "name", $$v)
              },
              expression: "clone.name",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item-wrapper" }, [
      _c("span", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.$t("ticimax.waitDayFromLastSend")) + ":"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "options" },
        [
          _c("a-input-number", {
            model: {
              value: _vm.clone.resendEnabledAfterDays,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "resendEnabledAfterDays", $$v)
              },
              expression: "clone.resendEnabledAfterDays",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }